import EFPicture from 'elem/compCommon/EFPicture';
import Clock from 'elem/SVGIcon/PowerBackup/Clock';
import Safe from '@elem/SVGIcon/VanlifeRoadtrips/Safe';
import Savings from 'elem/SVGIcon/PowerBackup/Savings';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang } = useGlobal();
    const { t } = useLang('powerindependence');
    const icons: any = [
        {
            icon: <Clock className="color" />,
            text: t('secD_tag1'),
        },
        {
            icon: <Savings className="color fill" />,
            text: t('secD_tag2'),
        },
        {
            icon: <Safe />,
            text: t('secD_tag3'),
        },
    ];
    return (
        <div id="power-independence-D" className={`power-independence-D ${css['power-independence-D']}`}>
            <div className="img-box">
                <EFPicture
                    src="/responsive/picture/power-independence/3.jpg"
                    srcMobile="/responsive/picture/power-independence/3_375.jpg"
                    srcPad="/responsive/picture/power-independence/3_375.jpg"
                    alt={t('secD_title')}
                />
                <div className="text-content">
                    <p className="title">{t('secD_title')}</p>
                    <p className="desc">{t('secD_desc')}</p>
                    <ul className="icons">
                        {icons?.map((icon: any) => (
                            <li className="icon-item" key={icon?.text}>
                                {icon?.icon}
                                <p className="icon-text">{icon?.text}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
